<template>
<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M672 192 288 511.936 672 832z"/></svg>
</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconCaretLeft',
} as DefineComponent
</script>